import { render, staticRenderFns } from "./Etapa1.vue?vue&type=template&id=a82cc066&scoped=true"
import script from "./Etapa1.vue?vue&type=script&lang=js"
export * from "./Etapa1.vue?vue&type=script&lang=js"
import style0 from "./Etapa1.vue?vue&type=style&index=0&id=a82cc066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82cc066",
  null
  
)

export default component.exports